import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { UIStyles } from '../../theme'
import { TextField } from '@mui/material'

const FilterContainer = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
`

// Soft white at rest and red only on hover, like the panel's other crosses.
const ClearButton = styled.div`
  cursor: pointer;
  color: ${UIStyles.whiteTransparent08};
  padding: 4px;
  margin-right: -4px;
  transition: color 0.15s;
  &:hover {
    color: ${UIStyles.redColor};
  }
`

function SamplesFilter({ t, onFilterChange, value }) {
  const [timeoutId, setTimeoutId] = useState(null)
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleSearchChange = e => {
    const newValue = e.target.value
    setLocalValue(newValue)

    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    const newTimeoutId = setTimeout(() => {
      onFilterChange({ target: { value: newValue } })
    }, 500)
    setTimeoutId(newTimeoutId)
  }

  const handleClear = () => {
    setLocalValue('')
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    onFilterChange({ target: { value: '' } })
  }

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [timeoutId])

  return (
    <FilterContainer>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={t('search samples')}
        onChange={handleSearchChange}
        value={localValue}
        size="small"
        InputProps={{
          endAdornment: localValue ? <ClearButton onClick={handleClear}>✕</ClearButton> : null
        }}
        // The pill of the main field search, with the panel's mint contour and a mint halo while typing.
        sx={{
          '& .MuiOutlinedInput-root': {
            color: UIStyles.whiteColor,
            borderRadius: '999px',
            backgroundColor: UIStyles.whiteTransparent01,
            transition: 'box-shadow 0.15s',
            '& fieldset': {
              borderColor: UIStyles.mintBorder
            },
            '&:hover fieldset': {
              borderColor: UIStyles.mintColor
            },
            '&.Mui-focused fieldset': {
              borderColor: UIStyles.mintColor,
              borderWidth: '1px'
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${UIStyles.mintColorTransparent}`
            }
          },
          '& .MuiInputBase-input::placeholder': {
            color: UIStyles.lightGrey,
            opacity: 1
          }
        }}
      />
    </FilterContainer>
  )
}

export default SamplesFilter
